export const EXPORT_FILE_TYPES = [
  {
    name: "Shape",
    extension: ".zip",
    fileType: "application/zip",
  },
  {
    name: "GeoJSON",
    extension: ".json",
    fileType: "application/json",
  },
  {
    name: "Csv",
    extension: ".csv",
    fileType: "text/csv",
  },
  {
    name: "XLSX",
    extension: ".xlsx",
    fileType: "text/xlsx",
  },
] as const;

export const EXPORT_DIALOG_STYLE = {
  maxWidth: "40rem",
  minHeight: "22.625rem",
};
